"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9363],{

/***/ 81867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70649);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98777);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);





var ArticleCard = function(param) {
    var article = param.article;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var currentLang = router.asPath.includes("/blog/en") ? "en" : "tr";
    var isFullSlug = (article === null || article === void 0 ? void 0 : article.category_slug.startsWith("/blog/tr")) || (article === null || article === void 0 ? void 0 : article.category_slug.startsWith("/blog/en"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-[500px] lg:h-[200px] mt-7 lg:mt-0 bg-white shadow-custom lg:shadow-none w-full p-7 space-y-7 lg:space-y-0 rounded-lg flex flex-col",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid flex-1 lg:grid-cols-5 lg:space-x-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: isFullSlug ? "".concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug) : "/blog/".concat(currentLang, "/").concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative h-[250px] w-full col-span-1 lg:col-span-2 lg:h-[160px] cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: (article === null || article === void 0 ? void 0 : article.image) ? "https://api-web.makdos.com/" + (article === null || article === void 0 ? void 0 : article.image) : "/dummyhighlight.svg",
                            layout: "fill",
                            alt: article === null || article === void 0 ? void 0 : article.title,
                            title: article === null || article === void 0 ? void 0 : article.title,
                            className: "rounded-md !h-[160px]"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col justify-between col-span-1 lg:col-span-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: isFullSlug ? "".concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug) : "/blog/".concat(currentLang, "/").concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "-mt-16 cursor-pointer lg:mt-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-2xl font-semibold",
                                        title: article === null || article === void 0 ? void 0 : article.title,
                                        children: (article === null || article === void 0 ? void 0 : article.title.length) > 65 ? (article === null || article === void 0 ? void 0 : article.title.substring(0, 65)) + "..." : article === null || article === void 0 ? void 0 : article.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm text-textGray",
                                        title: article === null || article === void 0 ? void 0 : article.description,
                                        children: (article === null || article === void 0 ? void 0 : article.description.length) > 110 ? (article === null || article === void 0 ? void 0 : article.description.substring(0, 110)) + "..." : article === null || article === void 0 ? void 0 : article.description
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between mt-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: isFullSlug ? article === null || article === void 0 ? void 0 : article.category_slug : "/blog/".concat(currentLang, "/").concat(article === null || article === void 0 ? void 0 : article.category_slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center p-2 space-x-2 text-sm rounded-full cursor-pointer text-textGray bg-buttonBg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-3 h-3 rounded-full bg-makdosYellow"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: (article === null || article === void 0 ? void 0 : article.category_title.length) > 15 ? (article === null || article === void 0 ? void 0 : article.category_title.substring(0, 15)) + "..." : article === null || article === void 0 ? void 0 : article.category_title
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: isFullSlug ? "".concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug) : "/blog/".concat(currentLang, "/").concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center space-x-3 cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex space-x-0.5 text-sm text-textGray",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "ri-calendar-2-line"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: moment__WEBPACK_IMPORTED_MODULE_2___default()(article === null || article === void 0 ? void 0 : article.create_time).format("DD.MM.YYYY")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex space-x-0.5 text-sm text-textGray",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "ri-user-line"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: (article === null || article === void 0 ? void 0 : article.created_by) ? article === null || article === void 0 ? void 0 : article.created_by : "Makdos"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCard);


/***/ }),

/***/ 92832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50959);





var CategoryList = function(param) {
    var allCategories = param.allCategories;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showCategories = ref[0], setShowCategories = ref[1];
    var currentLang = router.asPath.includes("/blog/en") ? "en" : "tr";
    var isFullSlug = allCategories.some(function(category) {
        var ref, ref1;
        return (category === null || category === void 0 ? void 0 : (ref = category.slug) === null || ref === void 0 ? void 0 : ref.startsWith("/blog/tr")) || (category === null || category === void 0 ? void 0 : (ref1 = category.slug) === null || ref1 === void 0 ? void 0 : ref1.startsWith("/blog/en"));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-3 mx-2 mt-8 bg-white rounded-lg lg:p-6 lg:my-0 lg:mx-0",
        children: [
            allCategories.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                className: "flex justify-between text-xl font-semibold",
                onClick: function() {
                    return setShowCategories(!showCategories);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "text-2xl lg:hidden ri-price-tag-3-fill "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    " ",
                                    t("blog:categories")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "ri-arrow-".concat(showCategories ? "up" : "down", "-s-line duration-500 lg:hidden")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:block ".concat(showCategories ? "block" : "hidden"),
                children: allCategories.slice(0, 10).map(function(category, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: isFullSlug ? "".concat(category === null || category === void 0 ? void 0 : category.slug) : "/blog/".concat(currentLang, "/").concat(category === null || category === void 0 ? void 0 : category.slug),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between py-4  cursor-pointer border-buttonBg ".concat(index === allCategories.length - 1 ? "" : "border-b lg:border-b-2"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm font-medium text-textGray",
                                    children: category === null || category === void 0 ? void 0 : category.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "flex items-center justify-center w-6 h-6 p-4 text-black rounded-full lg:text-textGray bg-buttonBg lg:bg-makdosYellow",
                                    children: category === null || category === void 0 ? void 0 : category.article_count
                                })
                            ]
                        })
                    }, index);
                })
            }),
            allCategories.length > 10 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full py-4 mt-5 rounded-full cursor-pointer text-textGray bg-buttonBg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "flex items-center justify-center",
                    children: [
                        " ",
                        t("blog:allCategories")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryList);


/***/ }),

/***/ 79907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13786);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63498);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);




var MostReadArticle = function(param) {
    var mostReadArticles = param.mostReadArticles;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var currentLang = router.asPath.includes("/blog/en") ? "en" : "tr";
    var isFullSlug = mostReadArticles.status !== "records_not_found" ? mostReadArticles.some(function(article) {
        var ref, ref1;
        return (article === null || article === void 0 ? void 0 : (ref = article.slug) === null || ref === void 0 ? void 0 : ref.startsWith("/blog/tr")) || (article === null || article === void 0 ? void 0 : (ref1 = article.slug) === null || ref1 === void 0 ? void 0 : ref1.startsWith("/blog/en"));
    }) : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "text-xl font-semibold",
                children: t("blog:mostReadArticle")
            }),
            mostReadArticles && mostReadArticles.length > 0 ? mostReadArticles.map(function(article, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: isFullSlug ? "".concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug) : "/blog/".concat(currentLang, "/").concat(article === null || article === void 0 ? void 0 : article.category_slug, "/").concat(article === null || article === void 0 ? void 0 : article.connection_id, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center p-3 space-x-3 cursor-pointer ".concat(index !== mostReadArticles.length - 1 ? "border-b-2 border-buttonBg" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "flex items-center justify-center w-6 h-6 p-4 text-black rounded-full bg-makdosYellow",
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "font-medium text-textGray",
                                children: article === null || article === void 0 ? void 0 : article.title
                            })
                        ]
                    })
                }, index);
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-4 text-center text-gray-500",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: t("blog:noMostReadArticles", "En \xe7ok okunan makale bulunamadı.")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MostReadArticle);


/***/ }),

/***/ 2045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Blog_SearchContent; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/FormElements/SimpleTextBox.js
var SimpleTextBox = __webpack_require__(53909);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
;// CONCATENATED MODULE: ./components/Blog/SearchInput.js





var SearchInput = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "blog"
    ]).t;
    var router = (0,next_router.useRouter)();
    var searchRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), searchValue = ref[0], setSearchValue = ref[1];
    var currentLang = router.asPath.includes("/blog/en") ? "en" : "tr";
    var handleSearch = function() {
        if (searchValue) {
            router.push("/blog/".concat(currentLang, "/").concat(currentLang === "tr" ? "arama" : "search", "?query=").concat(encodeURIComponent(searchValue)));
        }
    };
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            var ref;
            event.preventDefault();
            (ref = searchRef.current) === null || ref === void 0 ? void 0 : ref.click();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex py-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextBox/* default */.Z, {
                value: searchValue,
                onChange: setSearchValue,
                inputName: "search",
                placeholder: t("blog:search"),
                onKeyDown: handleKeyDown
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                ref: searchRef,
                href: "/blog/".concat(currentLang, "/").concat(currentLang === "tr" ? "arama" : "search", "?query=").concat(encodeURIComponent(searchValue)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "h-[39px] mt-6 lg:mt-1 -ml-4 lg:-ml-8 p-4 rounded-r-md flex items-center text-white bg-black",
                    children: [
                        t("blog:search"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mt-1 ml-2 text-lg ri-search-line"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Blog_SearchInput = (SearchInput);

;// CONCATENATED MODULE: ./components/Blog/SearchContent.js




var SearchContent = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "blog"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid items-center grid-cols-2 py-16 lg:space-x-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-12 mx-4 lg:space-y-8 lg:col-span-1 lg:mx-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-3xl font-bold text-center text-black lg:text-left lg:text-6xl",
                            children: t("blog:blogTitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_SearchInput, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-12 lg:col-span-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/searchContent.svg",
                        width: 572,
                        height: 572,
                        alt: "Makdos",
                        title: "Makdos"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Blog_SearchContent = (SearchContent);


/***/ }),

/***/ 68593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);


var SocialMediaContent = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "blog"
    ]).t;
    var socialMedia = [
        {
            id: 1,
            icon: "ri-instagram-line",
            link: "https://www.instagram.com/makdos.cloud/",
            name: "makdos.cloud"
        },
        {
            id: 2,
            icon: "ri-facebook-circle-line",
            link: "https://www.facebook.com/makdostech",
            name: "makdos"
        },
        {
            id: 3,
            icon: "ri-linkedin-line",
            link: "https://tr.linkedin.com/company/makdos",
            name: "makdos"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "hidden p-6 bg-white rounded-md lg:block",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: "pb-4 text-2xl font-semibold",
                children: t("blog:socialMedia")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-textGray",
                children: t("blog:followSocialMedia")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-5",
                children: socialMedia.map(function(media, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center justify-between pb-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "text-2xl text-black ".concat(media.icon)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: media.link,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-textGray",
                                        children: media.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-textGray px-4 py-2.5 rounded-full border-2 border-buttonBg cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: media.link,
                                    target: "_blank",
                                    children: t("blog:follow")
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialMediaContent);


/***/ })

}]);